import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxGalleryModule, DxButtonModule, DxTagBoxModule, DxScrollViewModule, DxTextBoxModule, DxDataGridModule, DxPopupModule, DxSelectBoxModule, DxDateBoxModule, DxTabPanelModule, DxAccordionModule, DxButtonGroupModule, DxCheckBoxModule, DxRangeSliderModule, DxDropDownButtonModule, DxRadioGroupModule, DxFileUploaderModule, DxTreeViewModule, DxContextMenuModule, DxDropDownBoxModule, DxSchedulerModule, DxAutocompleteModule, DxSliderModule, DxNumberBoxModule, DxToolbarModule, DxTextAreaModule, DxFormModule, DxTemplateModule } from "devextreme-angular";
import { LoginComponent } from './login.component';
import { LoginRoutingModule } from './login-routing.module';
// import { ResponsiveComponent } from './responsive/responsive.component';
@NgModule({
  declarations: [
    LoginComponent
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    MdbGlobalModule,
    DxButtonModule,
    DxTagBoxModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxDataGridModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxDateBoxModule,
    DxTabPanelModule,
    DxAccordionModule,
    DxButtonGroupModule,
    DxCheckBoxModule,
    DxRangeSliderModule,
    DxDropDownButtonModule,
    DxRadioGroupModule,
    DxFileUploaderModule,
    DxGalleryModule,
    DxTreeViewModule,
    DxDropDownBoxModule,
    DxContextMenuModule,
    DxSchedulerModule,
    DxAutocompleteModule,
    DxSliderModule,
    DxNumberBoxModule,
    DxToolbarModule,
    DxTextAreaModule,
    DxFormModule,
    DxTemplateModule
  ],
  exports:[LoginComponent]
})
export class LoginModule { }
